<h2>Pick Project Location</h2>
<mat-dialog-content>
  <digires-location-picker-map [position]="data" (mapClicked)="result=$event"></digires-location-picker-map>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btnNegative" mat-button [mat-dialog-close]="null">Cancel</button>
  <button class="btnPositive" mat-button [mat-dialog-close]="result">Ok</button>
</mat-dialog-actions>
